module.exports = __webpack_public_path__ + "img/ic_20_apple.f31f8619.svg";